import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import QRCode from '../../assets/images/QRcodes/youtube4thMonth.jpg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield, renderTableTD, renderTableTH} from '../../utils/templateUtils';
import './fourthMonthPregnancy.scss';

export default function FourthMonthPregnancy(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [ectopicRows, setEctopicRows] = useState([
    {
      outcome: '',
      conception: '',
      weeks: '',
      delivery: '',
      baby: '',
      complications: '',
      comments: ''
    }
  ]);
  const ecTopicHeaders = [
    {key: 'outcome', label: 'G Outcome', inputType: 'select', options: ['Term', 'Preterm', 'Miscarriage', 'Ectopic']},
    {key: 'conception', label: 'Mode of Conception', inputType: 'select', options: ['Natural', 'IUI', 'IVF']},
    {key: 'weeks', label: 'Weeks'},
    {key: 'delivery', label: 'Mode of Delivery', inputType: 'select', options: ['Vaginal', 'LSCS', 'Medical', 'Surgical Miscarriage']},
    {key: 'baby', label: 'Baby Outcome', inputType: 'select', options: ['Alive', 'Expired', 'Other']},
    {key: 'complications', label: 'Complications', inputType: 'select', options: ['BP', 'DM', 'BT', 'ICU', 'Nil', 'Other']},
    {key: 'comments', label: 'COMMENTS'}
  ];

  const [showTables, setShowTables] = useState({
    medication: true,
    ecTopic: true
  });

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: '1',
      drug: 'T. Furnext / Globac XT/ Ferronomic plus',
      genericName: 'Ferrous bisglycinate + Folic Acid + Zinc + Methylcobalamin',
      dosage: '',
      freq: '0-1-0',
      withFood: 'after food',
      duration: '30 Days'
    },
    {
      sno: '2',
      drug: 'C. Folvista',
      genericName: 'Methylfolate + Methylcobalamin + Pyridoxine',
      dosage: '1 capsule',
      freq: '0-1-0',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '3',
      drug: 'T. Tricium XT',
      genericName: 'Calcium Carbonate + Vitamin D3',
      dosage: '1 tablet',
      freq: '1-0-1',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '4',
      drug: 'Inj. Td Vac',
      genericName: 'Tetanus and Diphtheria Toxoid',
      dosage: '0.5 ml',
      freq: '-',
      withFood: '2nd dose due on: ______________',
      duration: '-'
    },
    {
      sno: '5',
      drug: 'Vivamom',
      genericName: 'Maternal Protein Supplement',
      dosage: '2 scoops',
      freq: 'Morning & Evening',
      withFood: 'With milk',
      duration: '1 box'
    },
    {
      sno: '6',
      drug: 'Siracilt',
      genericName: 'Silicone + Vitamin E + Plant Extracts',
      dosage: '',
      freq: 'Twice daily',
      withFood: 'For Stretch Marks, If Needed',
      duration: '-'
    },
    {
      sno: '7',
      drug: 'T. Thyronorm',
      genericName: 'Levothyroxine Sodium',
      dosage: 'As advised',
      freq: '1-0-0',
      withFood: 'Empty stomach',
      duration: '30 days'
    },
    {
      sno: '8',
      drug: 'T. Glycomet SR',
      genericName: 'Metformin Hydrochloride (Sustained Release)',
      dosage: 'As advised',
      freq: '1-0-1',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '9',
      drug: 'T. CVit',
      genericName: 'Ascorbic Acid (Vitamin C)',
      dosage: '',
      freq: '0-1-0',
      withFood: 'After food',
      duration: '30 Days'
    },
    {
      sno: '10',
      drug: 'T. Neuroplex',
      genericName: 'Multivitamin B-complex with Vitamin C',
      dosage: '',
      freq: '0-0-1',
      withFood: 'After food',
      duration: '30 Days'
    },
    {
      sno: '11',
      drug: 'INJ INFLUVAC TETRA',
      genericName: 'INACTIVATED INFLUENZA VACCINE(QUADRIVALENT)',
      dosage: '1 AMP IM',
      freq: 'STAT',
      withFood: '-',
      duration: '-'
    },
    {
      sno: '12',
      drug: 'Tab. Ecosprin 75/150',
      genericName: 'Aspirin 75/150 mg',
      dosage: '1 tablet',
      freq: '0-0-1',
      withFood: 'in the night after meal',
      duration: 'Till 34 weeks'
    }
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Brand Name'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dose'},
    {key: 'freq', label: 'Frequency'},
    {key: 'withFood', label: 'Timing / Instructions'},
    {key: 'duration', label: 'Duration'}
  ];

  const handleChange = e => {
    var text = e.target.value;

    if (e.target.name === 'patientId') {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || '').trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId') {
              setFormData({
                ...formData,
                patientName: namePat,
                age: data?.age,
                gender: data?.gender,
                patientId: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId') {
          setFormData({
            ...formData,
            patientId: e.target.value
          });
        }
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('fourthMonthPregnancyReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Spontaneous Pregnancy - 4 Month',
              picme_number: formData.picmeNumber,
              status: formData.picmeStatus
            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  useEffect(() => {
    if (props.patientsData.picme_number) {
      setFormData(prev => ({...prev, picmeNumber: props.patientsData.picme_number, picmeStatus: 'Registered'}));
    }
  }, [props.patientsData.picme_number]);

  return (
    <div id='FourthMonthPregnancyTemplate'>
      <div className='FourthMonthPregnancyTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>4th Month Antenatal Prescription – ASCAS</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <h3 className='mt-3'>OBSTETRIC SCORE :</h3>
          <div className='row'>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='G:' name='g' value={formData.g} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='P:' name='p' value={formData.p} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='A:' name='a' value={formData.a} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='L:' name='l' value={formData.l} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Ectopic:' name='ecTopic' value={formData.ecTopic} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          {showTables.ecTopic && (
            <TemplateTable
              id='ecTopic'
              title=''
              headers={ecTopicHeaders}
              rows={ectopicRows}
              onRowsChange={(id, newRows) => setEctopicRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('ecTopic', setShowTables)}
            />
          )}

          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel
                label='Period of Gestation (POG):'
                name='pog'
                value={formData.pog}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='Weeks'
                minWidth='250px'
              />
            </div>
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='complaints' className='fw-bold' style={{width: '180px'}}>
              Complaints:
            </label>
            <textarea className='Textarea' placeholder='Complaints' id='complaints' name='complaints' onChange={handleChange} rows='3' cols='100' />
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Screening Report:'
                name='screeningReport'
                value={formData.screeningReport}
                options={[
                  {label: 'Double Marker', value: 'Double Marker'},
                  {label: 'NIPT', value: 'NIPT'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
                minWidth='180px'
              />
            </div>
            <div className='col-md-6'>
              <SelectField
                label='Risk:'
                name='risk'
                value={formData.risk}
                options={[
                  {label: 'LOW RISK', value: 'LOW RISK'},
                  {label: 'INTERMEDIATE RISK', value: 'INTERMEDIATE RISK'},
                  {label: 'HIGH RISK', value: 'HIGH RISK'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Blood Reports:'
                name='bloodReports'
                value={formData.bloodReports}
                options={[
                  {label: 'Entered', value: 'Entered'},
                  {label: 'Not Entered', value: 'Not Entered'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
                minWidth='180px'
              />
            </div>
          </div>
          <h3 className='mt-3'>🩺 On Examination (O/E)</h3>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Pallor'
                name='pallor'
                value={formData.pallor}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-6'>
              <SelectField
                label='Pedal Edema'
                name='pedalEdema'
                value={formData.pedalEdema}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Pulse Rate (PR):' name='pulse' value={formData.pulse} required={false} onChange={handleChange} inputClassName='show' endLabel='bpm' minWidth='160px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BP:' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight:' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Previous Visit Weight:'
                name='previousWeight'
                value={formData.previousWeight}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='kg'
                minWidth='200px'
              />
            </div>
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='perAbdomen' className='fw-bold' style={{width: '180px'}}>
              Per Abdomen (P/A):
            </label>
            <textarea className='Textarea' placeholder='Uterus 16 weeks, relaxed, liquor average, FHS good' id='perAbdomen' name='perAbdomen' onChange={handleChange} rows='3' cols='100' />
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Cervical Length:'
                name='cervicalLength'
                value={formData.cervicalLength}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                minWidth='160px'
              />
            </div>
          </div>
          <h3 className='mt-3'>💉 Vaccination</h3>
          <div className='row pb-2'>
            <div className='col-md-6'>
              <SelectField
                label='Inj. Td vac 0.5 ml IM:'
                name='tdVac'
                value={formData.tdVac}
                options={[
                  {label: 'Given', value: 'Given'},
                  {label: 'Not Given', value: 'Not Given'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
                minWidth='200px'
              />
            </div>
          </div>
          <p>Tdap vaccine – Option discussed; to be taken between 27–36 weeks</p>
        </div>

        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='💊 Medications Advised'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}
        <div className='bulletin'>
          <h4>🧪 Investigations Before Next Visit</h4>
          <p>
            Ultrasound: Anomaly Scan + Fetal Echo on: <input type='date' name='anomalyScanDate' onChange={handleChange} />
          </p>
          <p>Blood Tests: CBC, Urine Routine & Culture, 75g GTT, TSH</p>
          <div className='row'>
            <div className='col-md-4 pb-2'>
              <SelectField
                label='📝 PICME Number'
                name='picmeStatus'
                value={formData.picmeStatus}
                options={[
                  {label: 'Registered', value: 'Registered'},
                  {label: 'Not Registered', value: 'Not Registered'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
                minWidth='160px'
              />
            </div>
            {formData.picmeStatus === 'Registered' && (
              <div className='col-md-6'>
                <ReportFormInputWithLabel label='Enter PICME Number:' name='picmeNumber' value={formData.picmeNumber} required={false} onChange={handleChange} inputClassName='show' minWidth='200px' />
              </div>
            )}
          </div>
        </div>

        <div className='bulletin'>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div>
              <h4>Tips for 4th Month Pregnancy</h4>
              <ul className='px-3'>
                <li>Eat small, frequent meals rich in iron, calcium, and protein.</li>
                <li>Start gentle exercises like walking or prenatal yoga with doctor’s advice.</li>
                <li>Sleep on your side with a pillow for back and belly support.</li>
                <li>Take your prenatal supplements regularly as prescribed.</li>
                <li>Fetal movements may begin between 18–22 weeks — be alert.</li>
                <li>👉 Watch the full second trimester guide by Dr. Aishwarya on</li>
                <li>
                  Doctor Mommies YouTube Channel:
                  <a href='https://www.youtube.com/watch?app=desktop&v=ejdW9akItdw' target='_blank' rel='noopener noreferrer'>
                    Second Trimester Video – Doctor Mommies
                  </a>
                </li>
              </ul>
            </div>
            <img src={QRCode} alt='youtube qr' style={{width: '100px', height: '100px'}} />
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div>
              <h4>✅ நான்காம் மாத கர்ப்பகால குறிப்புகள்</h4>
              <ul className='px-3'>
                <li>இரும்புச்சத்து, கால்சியம், புரதம் உள்ள சிறு சிறு உணவுகளை அடிக்கடி சாப்பிடுங்கள்.</li>
                <li>மருத்துவர் அனுமதியுடன் மென்மையான உடற்பயிற்சி (நடத்து/பிரிநாடல் யோகா) செய்யுங்கள்.</li>
                <li>பக்கவாட்டில் உறங்கும்போது தலையணையை பின்னிலும் வயிற்றிலும் வையுங்கள்.</li>
                <li>உங்கள் முன் போக்கும் மாத்திரைகளை தவறாமல் எடுத்துக்கொள்ளுங்கள்.</li>
                <li>18–22 வாரங்களுக்கு இடையில் குட்டியின் அசைவுகள் ஆரம்பிக்கலாம் — கவனியுங்கள்.</li>
                <li>👉 மேலும் தெரிந்துகொள்ள, டாக்டர் ஐஸ்வர்யா வழங்கும்</li>
                <li>
                  Doctor Mommies YouTube வீடியோவை பாருங்கள்:
                  <a href='https://www.youtube.com/watch?app=desktop&v=ejdW9akItdw' target='_blank' rel='noopener noreferrer'>
                    நடுத்தர கர்ப்ப காலம் – Doctor Mommies
                  </a>
                </li>
              </ul>
            </div>
            <img src={QRCode} alt='youtube qr' style={{width: '100px', height: '100px'}} />
          </div>
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='fourthMonthPregnancyReport'>
        <div id='fourthMonthPregnancyReportWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '5px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>4th Month Antenatal Prescription – ASCAS</h4>
          </div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>OBSTETRIC SCORE :</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('G:', formData.g)}
            {renderReportfield('P:', formData.p)}
            {renderReportfield('A:', formData.a)}
            {renderReportfield('L:', formData.l)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>{renderReportfield('Ectopic:', formData.ecTopic)}</div>
          {showTables.ecTopic &&
            renderDynamicTable(
              '',
              ['G Outcome', 'Mode of Conception', 'Weeks', 'Mode of Delivery', 'Baby Outcome', 'Complications', 'COMMENTS'],
              ['outcome', 'conception', 'weeks', 'delivery', 'baby', 'complications', 'comments'],
              ectopicRows
            )}
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>{renderReportfield('Period of Gestation (POG):', `${formData.pog ? formData.pog : ''} Weeks`)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Complaints:', formData.complaints)}</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Screening Report:', `${formData.screeningReport ? formData.screeningReport : ''} - ${formData.risk ? formData.risk : ''}`)}
            {renderReportfield('Blood Reports:', formData.bloodReports)}
          </div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>🩺 On Examination (O/E)</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Pallor:', formData.pallor)}
            {renderReportfield('Pedal Edema:', formData.pedalEdema)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Pulse Rate (PR):', `${formData.pulse ? formData.pulse : ''} bpm`)}
            {renderReportfield('BP:', `${formData.bp ? formData.bp : ''} mmHg`)}
            {renderReportfield('Weight:', `${formData.weight ? formData.weight : ''} kg`)}
            {renderReportfield('Previous Visit Weight:', `${formData.previousWeight ? formData.previousWeight : ''} kg`)}
          </div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Per Abdomen (P/A):', formData.perAbdomen)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Cervical Length:', formData.cervicalLength)}</div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>💉 Vaccination</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Inj. Td vac 0.5 ml IM:', formData.tdVac)}
            {renderReportfield('Tdap vaccine:', 'Option discussed; to be taken between 27–36 weeks')}
          </div>

          {showTables.medication && (
            <>
              {' '}
              <div style={{display: 'flex', marginTop: '5px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>💊 Medications Advised</h4>
              </div>
              <table
                style={{
                  marginBottom: '5px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{medicationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {medicationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.sno)}
                      {renderTableTD(row.drug)}
                      {renderTableTD(row.genericName)}
                      {renderTableTD(row.dosage)}
                      {renderTableTD(row.freq)}
                      {renderTableTD(row.withFood)}
                      {renderTableTD(row.duration)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>🧪 Investigations Before Next Visit</h6>
          </div>
          {[
            `Ultrasound: Anomaly Scan + Fetal Echo on: ${formData.anomalyScanDate ? formData.anomalyScanDate?.split('-').reverse().join('-') : ''}`,
            'Blood Tests: CBC, Urine Routine & Culture, 75g GTT, TSH'
          ].map((item, index) => (
            <div key={index} style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield(item, '', {styleSec: {width: '100%'}})}
            </div>
          ))}
          <div style={{display: 'flex', marginTop: '5px', marginLeft: '-10px'}}>{formData.picmeStatus === 'Registered' && renderReportfield('📝 PICME Number:', formData.picmeNumber)}</div>

          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>Tips for 4th Month Pregnancy</h6>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            {/* Left content */}
            <div>
              {[
                'Eat small, frequent meals rich in iron, calcium, and protein.',
                'Start gentle exercises like walking or prenatal yoga with doctor’s advice.',
                'Sleep on your side with a pillow for back and belly support.',
                'Take your prenatal supplements regularly as prescribed.',
                'Fetal movements may begin between 18–22 weeks — be alert.',
                '👉 Watch the full second trimester guide by Dr. Aishwarya on',
                'Doctor Mommies YouTube Channel: <a href="https://www.youtube.com/watch?app=desktop&v=ejdW9akItdw" target="_blank" rel="noopener noreferrer">Second Trimester Video – Doctor Mommies</a>'
              ].map((item, index) => (
                <div key={index} style={{display: 'flex', marginBottom: '5px'}} dangerouslySetInnerHTML={{__html: item}}></div>
              ))}
            </div>

            {/* Right QR code */}
            <div>
              <img src={QRCode} alt='youtube qr' style={{width: '100px', height: '100px'}} />
            </div>
          </div>

          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>✅ நான்காம் மாத கர்ப்பகால குறிப்புகள்</h6>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            <div>
              {[
                'இரும்புச்சத்து, கால்சியம், புரதம் உள்ள சிறு சிறு உணவுகளை அடிக்கடி சாப்பிடுங்கள்.',
                'மருத்துவர் அனுமதியுடன் மென்மையான உடற்பயிற்சி (நடத்து/பிரிநாடல் யோகா) செய்யுங்கள்.',
                'பக்கவாட்டில் உறங்கும்போது தலையணையை பின்னிலும் வயிற்றிலும் வையுங்கள்.',
                'உங்கள் முன் போக்கும் மாத்திரைகளை தவறாமல் எடுத்துக்கொள்ளுங்கள்.',
                '18–22 வாரங்களுக்கு இடையில் குட்டியின் அசைவுகள் ஆரம்பிக்கலாம் — கவனியுங்கள்.',
                '👉 மேலும் தெரிந்துகொள்ள, டாக்டர் ஐஸ்வர்யா வழங்கும்',
                'Doctor Mommies YouTube வீடியோவை பாருங்கள்: <a href="https://www.youtube.com/watch?app=desktop&v=ejdW9akItdw" target="_blank" rel="noopener noreferrer">நடுத்தர கர்ப்ப காலம் – Doctor Mommies</a>'
              ].map((item, index) => (
                <div key={index} style={{display: 'flex', marginBottom: '5px'}} dangerouslySetInnerHTML={{__html: item}}></div>
              ))}
            </div>

            <div>
              <img src={QRCode} alt='youtube qr' style={{width: '100px', height: '100px'}} />
            </div>
          </div>

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
